import React from 'react';

const Chapters = ({fill = '#fff'}) => {
  return (
    <svg width="30" height="25" viewBox="0 0 30 25" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="m2.775 0c1.53 0 2.775 1.215 2.775 2.715s-1.245 2.715-2.775 2.715c-1.535 0-2.775-1.215-2.775-2.715s1.24-2.715 2.775-2.715z" />
      <path d="m10.065 2.16998h19.935v1.22h-19.935z" />
      <path d="m2.775 9.79498c1.53 0 2.775 1.21002 2.775 2.70502s-1.245 2.705-2.775 2.705c-1.535 0-2.775-1.21-2.775-2.705s1.24-2.70502 2.775-2.70502z" />
      <path d="m10.065 11.965h19.935v1.22h-19.935z" />
      <path d="m2.775 19.57c1.53 0 2.775 1.215 2.775 2.715s-1.245 2.715-2.775 2.715c-1.535 0-2.775-1.215-2.775-2.715s1.24-2.715 2.775-2.715z" />
      <path d="m10.065 21.72h19.935v1.22h-19.935z" />
    </svg>
  );
};

export default Chapters;


// WEBPACK FOOTER //
// ./src/components/svg-icons/Chapters.jsx